<template>
  <div class="main-nav">
    <div class="container">
      <div class="row u-flex--item-center">
        <div class="col-lg-3 col-6">
          <div class="site-logo">
            <router-link :to="{ path: '/' }"
              ><img src="/src/assets/img/logo/logo-white.png" alt="Logo"
            /></router-link>
          </div>
        </div>
        <div class="col-lg-8 d-none d-lg-block u-padding-r-0">
          <nav class="header__nav text-right">
            <ul>
              <li
                v-for="category in categories.filter(
                  (c) => c.postCategoryID != 18
                )"
                :key="category.postCategoryID"
                v-bind:class="{
                  'has-dropdown':
                    category.postSubcategories &&
                    category.postSubcategories.length > 0,
                }"
              >
                <router-link
                  :to="{
                    name: 'category',
                    params: { category: category.searchCode },
                  }"
                  >{{ category.name }}</router-link
                >
                <ul
                  v-if="
                    category.postSubcategories &&
                    category.postSubcategories.length > 0
                  "
                  class="menu-dropdown"
                >
                  <li
                    v-for="subcategory in category.postSubcategories"
                    :key="subcategory.postSubcategoryID"
                  >
                    <router-link
                      :to="{
                        name: 'category',
                        params: {
                          category: category.searchCode,
                          subcategory: subcategory.postSubcategorySearchCode,
                        },
                      }"
                      >{{ subcategory.name }}</router-link
                    >
                  </li>
                </ul>
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'category',
                    params: { category: 'multimedija' },
                  }"
                  >Multimedija</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{
                    name: 'category',
                    params: {
                      category: 'bh-telecom-predstavlja',
                      subcategory:
                        'poznate-licnosti-i-historijat-telekomunikacija',
                    },
                  }"
                >
                  <div class="image-container">
                    <img
                      src="/src/assets/img/bht-predstavlja.png"
                      width="100"
                    />
                  </div>
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-lg-1 col-6">
          <div class="header__search has-menubar text-right">
            <button
              class="header__menubar d-lg-none d-xl-none"
              v-on:click="openMobileMenu()"
            >
              <i class="ico-bar"></i>
            </button>
            <button
              class="header__search__btn d-none d-lg-inline-block"
              v-on:click="showSearchForm()"
            >
              <i class="fa fa-search"></i>
            </button>
            <div class="header__search__form">
              <div class="header__search__inner">
                <button v-on:click="hideSearchForm()" class="close-btn">
                  <i class="ico-close"></i>
                </button>
                <div class="header__search__form-wrapper">
                  <button v-on:click="search()" class="search-action">
                    <span class="ico-search"></span>
                  </button>
                  <input
                    v-model="searchTerm"
                    v-on:keyup.enter="search()"
                    class="search-input"
                    type="text"
                    placeholder="Unesite termin za pretragu..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobile menu area start -->
    <div class="mobile-menu-area">
      <div class="btn-wrap">
        <button v-on:click="closeMobileMenu()">
          <i class="ico-close"></i>
        </button>
      </div>
      <div class="search-form">
        <input
          v-model="searchTerm"
          placeholder="Unesite termin za pretragu..."
          type="text"
        />
        <button v-on:click="search()"><i class="ico-search"></i></button>
      </div>
      <nav class="mobile-menu">
        <ul>
          <li
            v-for="category in categories.filter((c) => c.postCategoryID != 16)"
            :key="category.postCategoryID"
          >
            <router-link
              class="collapsed"
              @click.native="toggleMobileSubmenu(category.postCategoryID)"
              v-bind:class="{
                'has-child':
                  category.postSubcategories &&
                  category.postSubcategories.length > 0,
              }"
              :to="{
                name: 'category',
                params: { category: category.searchCode },
              }"
              >{{ category.name }}</router-link
            >
            <ul
              v-bind:id="'mobileSubmenu_' + category.postCategoryID"
              class="collapse"
            >
              <li
                v-for="subcategory in category.postSubcategories"
                :key="subcategory.postSubcategoryID"
                v-on:click="closeMobileMenu()"
              >
                <router-link
                  :to="{
                    name: 'category',
                    params: {
                      category: category.searchCode,
                      subcategory: subcategory.postSubcategorySearchCode,
                    },
                  }"
                  >{{ subcategory.name }}</router-link
                >
              </li>
            </ul>
          </li>
          <li v-on:click="closeMobileMenu()">
            <router-link
              :to="{ name: 'category', params: { category: 'multimedija' } }"
              >Multimedija</router-link
            >
          </li>
          <li v-on:click="closeMobileMenu()">
            <router-link
              :to="{
                name: 'category',
                params: {
                  category: 'bh-telecom-predstavlja',
                  subcategory: 'poznate-licnosti-i-historijat-telekomunikacija',
                },
              }"
              ><img src="/src/assets/img/bht.png" />&nbsp;
              <span class="bht-font-color">Predstavlja</span></router-link
            >
          </li>
        </ul>
      </nav>
      <div class="social-links">
        <ul>
          <li>
            <a href="#"><span class="ion-social-facebook"></span></a>
          </li>
          <li>
            <a href="#"><span class="ion-social-twitter"></span></a>
          </li>
          <li>
            <a href="#"><span class="ion-social-googleplus"></span></a>
          </li>
          <li>
            <a href="#"><span class="ion-social-tumblr"></span></a>
          </li>
        </ul>
      </div>
    </div>
    <!--// Mobile menu area end -->
  </div>
</template>

<script>
import { CategoriesService } from '../common/api.service'

export default {
  name: "Navbar",
  data() {
    return {
      categories: [],
      searchTerm: ""
    }
  },
  created() {
    CategoriesService.get().then(res => this.categories = res.data);
  },
  methods: {
    showSearchForm: function () {
      var $searchForm = document.getElementsByClassName("header__search__form")[0];
      $searchForm.style.visibility = "visible";
      $searchForm.style.opacity = "1";
    },
    hideSearchForm: function () {
      var $searchForm = document.getElementsByClassName("header__search__form")[0];
      $searchForm.style.visibility = "hidden";
      $searchForm.style.opacity = "0";
    },
    search: function () {
      this.$router.push({ name: 'category', query: { pretraga: this.searchTerm } });
      this.hideSearchForm();
      this.searchTerm = null;
    },
    openMobileMenu: function () {
      document.getElementsByTagName("body")[0].classList.add("JS-show-menu");
    },
    closeMobileMenu: function () {
      document.getElementsByTagName("body")[0].classList.remove("JS-show-menu");
    },
    toggleMobileSubmenu: function (postCategoryID) {
      var currrentDisplayValue = document.getElementById("mobileSubmenu_" + postCategoryID).style.display;
      document.getElementById("mobileSubmenu_" + postCategoryID).style.display = currrentDisplayValue === "block" ? "none" : "block";
    }
  }
}
</script>

<style scoped>
.main-nav {
  background: #052962;
}

.site-logo {
  width: 250px;
}

.header__nav a {
  color: white;
  margin-right: 25px;
}

.header__search button {
  color: white;
}

.close-btn {
  color: #585858 !important;
}

.search-form {
  position: relative;
}

.mobile-menu-area .search-form input {
  width: 100%;
  height: 50px;
  padding: 0 50px 0 10px;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  color: #fff;
  border: 1px solid #717171;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  background: 0 0;
}

.mobile-menu-area .search-form button {
  position: absolute;
  top: 0;
  right: 15px;
  width: 40px;
  height: 50px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  color: #717171;
  border: 0;
  background: 0 0;
  line-height: 50px;
}

.image-container:hover {
  opacity: 0.8;
}

.bht-font-color {
  color: #f9a632;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue